var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfoIcon = function SvgInfoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 2.25A9.75 9.75 0 1 0 21.75 12 9.77 9.77 0 0 0 12 2.25m-.187 4.5a1.125 1.125 0 1 1 0 2.25 1.125 1.125 0 0 1 0-2.25m.937 10.5H12a.75.75 0 0 1-.75-.75V12a.75.75 0 1 1 0-1.5H12a.75.75 0 0 1 .75.75v4.5a.75.75 0 1 1 0 1.5"
  })));
};
export default SvgInfoIcon;